import React from "react";
import ReactModal from "react-modal";
import Button from "./controls/button";
import "less/modal.less";

const ariaLabelByType = (type, title) => {
  switch (type) {
    case "modal":
      return title || type;
    default:
      return type;
  }
};

const Modal = ({
  title, // header text
  children, // modal content
  onSubmit,
  onCancel,
  submitBtnText = "Submit",
  cancelBtnText = "Cancel",
  submittable = true,
  isSubmitting = false,
  // If submit button is displayed, enable it?
  enableSubmit = true,
  enableCancel = true,
  cancelable = true,
  isOpen = true,
  type = "modal",
  autoFocusSubmit = true,
  className = "",
  contentLabel,
  additionalButtons = [],
  showCancelBtn = true,
  showSubmitBtn = true,
  showXBtn = true,
  // Pasthrough to React Modal
  style,
  classNameTitle = "react-modal",
  classNameHeader = "react-modal-header",
  classNameContent = "react-modal-content",
  classNameFooter = "react-modal-footer",
  // Accessibility: control auto focus when modal opens
  shouldFocusAfterRender = true,
}) => (
  <ReactModal
    contentLabel={ariaLabelByType(
      type,
      contentLabel != null ? contentLabel : title
    )}
    isOpen={isOpen}
    onRequestClose={cancelable ? onCancel : undefined}
    className={`${classNameTitle} type-${type} ${className}`}
    overlayClassName="react-modal-backdrop"
    shouldFocusAfterRender={shouldFocusAfterRender}
    {...{ style }}
  >
    {type === "modal" && (
      <div className={classNameHeader}>
        {cancelable ? (
          <div className="actions-wrap">
            {title}
            {showXBtn && (
              <i onClick={onCancel} className="cancel im-ss-delete" />
            )}
          </div>
        ) : (
          title
        )}
      </div>
    )}
    <div className={classNameContent}>{children}</div>
    <div className={`${classNameFooter} clearfix`}>
      <span className="react-modal-footer-actions pull-right">
        {cancelable && showCancelBtn && (
          <Button
            className="cancel"
            onClick={onCancel}
            disabled={!enableCancel}
          >
            {cancelBtnText}
          </Button>
        )}
        {additionalButtons}
        {submittable && showSubmitBtn && (
          <Button
            className="submit"
            autoFocus={type === "dialog" && autoFocusSubmit}
            onClick={onSubmit}
            disabled={!enableSubmit}
            isLoading={isSubmitting}
          >
            {submitBtnText}
          </Button>
        )}
      </span>
    </div>
  </ReactModal>
);

export default Modal;

export const { setAppElement } = ReactModal;
